import React, { useEffect, useCallback, useState} from 'react';
import ethereum from 'decentralized/ethereum.js';
import {connect} from 'react-redux';
import ipfs from 'decentralized/Ipfs.js';

const WorkList = ({work, onClick}) => { 
    let [listData, setListData] = useState(undefined);
    let [userName, setUserName] = useState('');
    let [projects, setProjects] = useState([]);
    let [thumbnail, setThumbnail] = useState('');

    useEffect(() => {
        // if its not loaded then 
        if (work.projects) {
            console.log("there was work.projects and work.image =", work.image);
            setProjects(work.projects);
            setThumbnail(ipfs.getHashUrl(work.image));
            setListData({
                ... work});
        } else {
            ipfs.getJson(work.newContent).then(
                json => {
                    setListData({
                        ... work,
                        ... json
                    });
                    setThumbnail(ipfs.getHashUrl(json.image));
                    setProjects(json.projects);
                });
        }
    }, [work]);

    useEffect(() => {
        ethereum.users.getUserName(work.user).then(
            setUserName);
    }, [work, setUserName]);

    let style = {
        backgroundImage: "url(" + thumbnail + ")"
    };

    return (
        <div onClick={() => onClick(listData)} style={style} className="work list">
          <div className="projects">
            {projects.map(
                x =>
                    <div className="project">
                      {x.title} .
                    </div>)}
          </div>
          <div className="list-author">{userName}</div>
          <div className="list-title">{work.title}</div>
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WorkList);
